import { useEffect, useState } from 'react';
import { isAppVisible, onAppVisibilityChange } from '@/native/platform';

/**
 * Whether the app is being looked at.
 *
 * Every polling surface in the client reads this and passes `refetchInterval: visible ? … :
 * false` — React Query's "no interval" — so a phone in a pocket asks for nothing and picks the
 * timer back up on the visibility change rather than on a schedule. One hook rather than one per
 * poller, because "stop polling when nobody is looking" is a rule and not a per-component taste.
 */
export function useAppVisible(): boolean {
  const [visible, setVisible] = useState(isAppVisible);
  useEffect(() => onAppVisibilityChange(setVisible), []);
  return visible;
}
